import React from "react"
import {DigitalDocumentFieldSetUp} from "types/tasks"
import {Signature, DateField, Initials, Text, Checkbox, Select, Grade, File} from "./parts"
import {useConditionalField} from "../TaskSubmission/useConditionalField"

type Props = {
    field: any
    fields: any[]
    onChangeRemarkField: (fieldId: string, comment: string) => void
}

export function ObservationField(props: Props) {
    const {field, fields, onChangeRemarkField} = props

    const {checkFieldCanShow} = useConditionalField()
    const canShow = checkFieldCanShow({field, fields})

    if (!canShow) {
        return null
    }

    switch (field.type) {
        case DigitalDocumentFieldSetUp.SIGNATURE:
            return <Signature field={field} onChangeRemarkField={onChangeRemarkField} />
        case DigitalDocumentFieldSetUp.DATE_FIELD:
            return <DateField field={field} onChangeRemarkField={onChangeRemarkField} />
        case DigitalDocumentFieldSetUp.INITIAL:
            return <Initials field={field} onChangeRemarkField={onChangeRemarkField} />
        case DigitalDocumentFieldSetUp.TEXT:
            return <Text field={field} onChangeRemarkField={onChangeRemarkField} />
        case DigitalDocumentFieldSetUp.GRADE:
            return <Grade field={field} onChangeRemarkField={onChangeRemarkField} />
        case DigitalDocumentFieldSetUp.FILE:
            return <File field={field} onChangeRemarkField={onChangeRemarkField} />
        case DigitalDocumentFieldSetUp.CHECKBOX:
            return <Checkbox field={field} onChangeRemarkField={onChangeRemarkField} />
        case DigitalDocumentFieldSetUp.SELECT:
            return <Select field={field} onChangeRemarkField={onChangeRemarkField} />
        default:
            return null
    }
}
